export const PROVIDER_CODES = ['OFAC', 'UNCS', 'BIS', 'WBP', 'FBI', 'JMOPM', 'JMGOV'];

export const PROVIDER_LABELS = {
  OFAC:  'OFAC Specially Designated Nationals',
  UNCS:  'UN Security Council Consolidated List',
  BIS:   'US Bureau of Industry and Security',
  WBP:   'World Bank Debarred Firms & Individuals',
  FBI:   'FBI Wanted',
  JMOPM: 'Jamaica Table of Precedence (PEPs)',
  JMGOV: 'Jamaica MPs & Councillors (PEPs)',
  UN:    'UN Security Council Consolidated List',
};

// Short names for badges.
export const PROVIDER_SHORT = {
  OFAC: 'OFAC', UNCS: 'UN', UN: 'UN', BIS: 'BIS', WBP: 'World Bank',
  FBI: 'FBI', JMOPM: 'JA Precedence', JMGOV: 'JA Gov',
};

export const DATA_SET_OPTIONS = [
  { text: 'Sanctions', value: 'sanction' },
  { text: 'PEPs',      value: 'pep' },
  { text: 'Criminal',  value: 'criminal' },
];

const DATE_METHOD_LABELS = {
  embedded:        'Published by the list owner',
  http_header:     'Published by the list owner',
  max_record_date: 'Latest change to the list',
  observed_change: 'First seen by the screening system',
};

export function providerLabel(code) {
  return PROVIDER_LABELS[code] || code || '—';
}

export function providerShort(code) {
  return PROVIDER_SHORT[code] || code || '—';
}

export function dateMethodLabel(method) {
  return DATE_METHOD_LABELS[method] || '';
}

// "2026-10-28" from a date or timestamp; '' if missing.
export function isoDate(value) {
  if (!value) return '';
  const s = String(value);
  return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : s;
}

// Text for a list edition, e.g. "2026-10-28 (published by the list owner)".
export function describeListDate(date, method) {
  const d = isoDate(date);
  if (!d) return '';
  const m = dateMethodLabel(method);
  return m ? `${d} (${m.charAt(0).toLowerCase()}${m.slice(1)})` : d;
}

// Items for provider pickers. With live status from the API, each item shows the list's date.
export function providerItems(sources) {
  if (!sources || !sources.length) {
    return PROVIDER_CODES.map(code => ({ text: providerLabel(code), value: code }));
  }
  return sources.map(s => ({
    text:  s.list_updated_at ? `${s.label} — ${isoDate(s.list_updated_at)}` : s.label,
    value: s.source_code,
  }));
}

export function isSafeUrl(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url);
}

export const HIDDEN_META_KEYS = [
  'source_document', 'source_list_url', 'source_information_url', 'csl_id', 'url', 'path',
];